module.exports = __webpack_public_path__ + "static/img/character.0fddde6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character.png
// module id = sM2+
// module chunks = 1